<!-- eslint-disable max-len -->
<template>
  <section>
    <div id="app">
      <Navbar v-if="this.$route.meta.requiresAuth" />
      <router-view />
      <Footer />
    </div>
  </section>
</template>

<script>
import Navbar from './components/Navbar.vue';
import Footer from './components/Footer.vue';

export default {
  components: {
    Navbar,
    Footer,
  },
  created() {
    if (this.$workbox) {
      this.$workbox.addEventListener('waiting', () => {
        this.showUpdateUI = true;
      });
    }
  },
  async accept() {
    this.showUpdateUI = false;
    await this.$workbox.messageSW({ type: 'SKIP_WAITING' });
  },
  metaInfo() {
    return {
      title: 'Matkortet Console',
      meta: [
        {
          name: 'description',
          content:
            'Manage organisations, food-cards and users via the powerful adminstrative console of Matkortet.',
        },
      ],
    };
  },
};
</script>

<style lang="scss">
html,
body {
  margin: 0;
  padding: 0;
  background: #f9fafb;
}
</style>
